import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { localizeDateTime, getStyles } from '../../../../shared/utility';
import { isDate, modifyDate } from '../DateTimeHelpers';

import Dropdown from '../../Dropdown/Dropdown';

import localStyles from './TimePicker.scss';
const styles = getStyles(localStyles);

class TimePicker extends Component {
    /* * * * * * * * *
     * REACT METHODS *
     * * * * * * * * */
    constructor(props) {
        super(props);

        this.today = modifyDate(new Date());

        this.state = {
            min: this.props.minDate ? this.props.minDate === 'today' ? this.today : this.props.minDate : null,
            max: this.props.maxDate ? this.props.maxDate === 'today' ? this.today : this.props.maxDate : null,
            time: isDate(this.props.value) ? this.dateToMSOnDay(this.props.value) : null
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.time !== this.state.time && Number.isInteger(this.state.time)) {
            this.props.select(new Date(this.state.time));
        }

        const newState = {};
        if(prevProps.minDate !== this.props.minDate){
            newState.min = this.props.minDate ? this.props.minDate === 'today' ? this.today : this.props.minDate : null;
        }
        if(prevProps.maxDate !== this.props.maxDate){
            newState.max = this.props.maxDate ? this.props.maxDate === 'today' ? this.today : this.props.maxDate : null;
        }

        if(Object.keys(newState).length){
            this.setState(newState);
        }
    }

    /* * * * * * * * * *
     * CUSTOM METHODS  *
     * * * * * * * * * */
    selectTime = (value) => {
        this.setState({ time: (value.length ? value[0] : null) });
        this.props.focusNext();
    }

    dateToMSOnDay = (date) => !isDate(date) ? 0 : (date.getHours() * 60 + date.getMinutes()) * 60 * 1000;
    MSOnDayToString = (ms) => localizeDateTime(new Date(ms), this.props.locale, { timeZone: 'UTC', hour: '2-digit', minute: '2-digit' });

    roundToStepsize = (time) => this.props.roundStepsize ? Math.ceil(time / this.props.stepsize) * this.props.stepsize : time;

    getEarliestTime = () => {
        let earliest = this.dateToMSOnDay(this.props.earliest);
        if(isDate(this.props.value) && isDate(this.props.minDate) && modifyDate(this.props.value, {hours: 0, minutes: 0}) - modifyDate(this.props.minDate, {hours: 0, minutes: 0}) === 0){
            earliest = Math.max(this.dateToMSOnDay(this.props.minDate), earliest);
        }
        return earliest;
    }

    getLatestTime = () => {
        let latest = this.dateToMSOnDay(this.props.latest);
        if(isDate(this.props.value) && isDate(this.props.maxDate) && modifyDate(this.props.value, {hours: 0, minutes: 0}) - modifyDate(this.props.maxDate, {hours: 0, minutes: 0}) === 0){
            latest = Math.min(this.dateToMSOnDay(this.props.maxDate), latest);
        }
        return latest;
    }

    getTimes = () => {
        let time = Math.max(0, this.roundToStepsize(this.getEarliestTime()));
        const latest = Math.min((23 * 60 + 59) * 60 * 1000, this.roundToStepsize(this.getLatestTime()));

        const output = [];

        while (time <= latest) {
            output.push({
                value: time,
                selected: this.state.time === time && this.props.set,
                text: localizeDateTime(new Date(time), this.props.locale, { timeZone: 'UTC', hour: '2-digit', minute: '2-digit' })
            });
            time += this.props.stepsize;
        }
        return output;
    }

    /* * * * * *
     * RENDER  *
     * * * * * */
    render() {
        return (
            <div className={styles('timepicker')}>
                <Dropdown
                    options={this.getTimes()}
                    collapsed={true}
                    callback={this.selectTime}
                    dropdownOnly={true}
                    isOpen={this.props.isOpen}
                />
            </div>
        );
    }

}

TimePicker.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    set: PropTypes.bool.isRequired,

    value: PropTypes.instanceOf(Date),

    earliest: PropTypes.instanceOf(Date).isRequired,
    latest: PropTypes.instanceOf(Date).isRequired,

    minDate: PropTypes.oneOfType([
        PropTypes.instanceOf(Date),
        PropTypes.oneOf(['today'])
    ]),
    maxDate: PropTypes.oneOfType([
        PropTypes.instanceOf(Date),
        PropTypes.oneOf(['today'])
    ]),

    stepsize: PropTypes.number.isRequired,
    roundStepsize: PropTypes.bool.isRequired,

    select: PropTypes.func.isRequired,
    focusNext: PropTypes.func.isRequired,

    locale: PropTypes.string.isRequired
};

export default TimePicker;



// WEBPACK FOOTER //
// ./src/components/UI/DateTimePicker/TimePicker/TimePicker.js